import { getAssetsPath } from "./utils/pathConfig";

// Use centralized path configuration
const BASE_PATH = getAssetsPath();

// ============================================================================
// AUDIO SPRITE CONFIGURATION
// ============================================================================
// Generated with: npx audiosprite --output sfx-sprite --export mp3 --format howler sprite-source/*.mp3
// This combines 48 one-shot sounds into a single MP3 file
// Format: soundName: [startTime_ms, duration_ms]
const SFX_SPRITE_MAP = {
  add_respin: [0, 467.1428571428571],
  big_win: [2000, 4104.081632653061],
  button_click: [8000, 233.56009070294803],
  buy_bonus: [10000, 2669.319727891157],
  coin: [14000, 1468.1405895691614],
  coin_multiplier: [17000, 1968.6394557823128],
  coin_win: [20000, 1384.489795918366],
  collector_add: [23000, 1835.1700680272102],
  collector_appear: [26000, 1835.1700680272102],
  collector_particle: [29000, 1368.0272108843533],
  drop_10: [32000, 2734.1723356009097],
  drop_11: [36000, 3443.038548752831],
  drop_12: [41000, 3443.038548752831],
  drop_1: [46000, 2038.616780045352],
  drop_2: [50000, 1860.7709750566883],
  drop_3: [53000, 2063.2879818594106],
  drop_4: [57000, 987.3242630385519],
  drop_5: [59000, 607.5963718820888],
  drop_6: [61000, 1265.8049886621327],
  drop_7: [64000, 1746.8480725623579],
  drop_8: [67000, 3696.1904761904807],
  drop_9: [72000, 2784.8072562358225],
  expanding_wild: [76000, 1935.2607709750628],
  expanding_wild_multiplier: [79000, 1167.8231292517012],
  feature_end: [82000, 1901.9047619047597],
  feature_reel_stop: [85000, 167.1882086167784],
  feature_tension: [87000, 5638.956916099773],
  hold_and_win_in: [94000, 3803.786848072562],
  hold_and_win_out: [99000, 1167.8231292517012],
  hold_and_win_reload_in: [102000, 3030.2040816326466],
  hold_and_win_reload_out: [107000, 1384.4897959183697],
  max_win_in: [110000, 3395.918367346937],
  max_win_out: [115000, 2000],
  mega_win: [118000, 4070.748299319732],
  progress_bar_add: [124000, 567.233560090699],
  progress_bar_milestone: [126000, 2135.464852607697],
  progress_bar_multiplier: [130000, 3317.55102040816],
  reel_stop: [135000, 266.9160997732547],
  spin: [137000, 467.1428571428464],
  super_mega_win: [139000, 4337.664399092972],
  tension: [145000, 3316.43990929706],
  total_win_in: [150000, 3631.0204081632664],
  total_win_out: [155000, 2000],
  transition_in: [158000, 4537.8458049886485],
  transition_outro: [164000, 4537.86848072562],
  wild: [170000, 1935.2607709750487],
  win: [173000, 1468.140589569174],
  win_music_end: [176000, 4000],
};

export const GAME_SOUNDS = {
  sounds: [
    // ========================================================================
    // LOOPING SOUNDS - Kept separate for seamless loops
    // ========================================================================
    {
      name: "ambient_music",
      url: `${BASE_PATH}/sounds/ambient_music.mp3`,
      loop: true,
      volume: 1,
    },
    {
      name: "background_music",
      url: `${BASE_PATH}/sounds/background_music.mp3`,
      loop: true,
      volume: 1,
    },
    {
      name: "feature_background_music",
      url: `${BASE_PATH}/sounds/feature_background_music.mp3`,
      loop: true,
      volume: 1,
    },
    {
      name: "reel_spin",
      url: `${BASE_PATH}/sounds/reel_spin.mp3`,
      volume: 1,
      loop: true,
    },
    {
      name: "feature_reel_spin",
      url: `${BASE_PATH}/sounds/feature_reel_spin.mp3`,
      volume: 1,
      loop: true,
    },
    {
      name: "counter",
      url: `${BASE_PATH}/sounds/counter.mp3`,
      loop: true,
      volume: 1,
    },
    {
      name: "collector_counter",
      url: `${BASE_PATH}/sounds/collector_counter.mp3`,
      loop: true,
      volume: 1,
    },
    {
      name: "total_win_loop",
      url: `${BASE_PATH}/sounds/total_win_loop.mp3`,
      loop: true,
      volume: 1,
    },
    {
      name: "win_music",
      url: `${BASE_PATH}/sounds/win_music.mp3`,
      loop: true,
      volume: 1,
    },
    {
      name: "progress_bar_tension",
      url: `${BASE_PATH}/sounds/progress_bar_tension.mp3`,
      loop: true,
      volume: 1,
    },
    {
      name: "tension_shake",
      url: `${BASE_PATH}/sounds/tension_shake.mp3`,
      loop: true,
      volume: 1,
    },

    // ========================================================================
    // SFX AUDIO SPRITE - All one-shot sounds combined (48 sounds → 1 file)
    // ========================================================================
    {
      name: "sfx_sprite",
      url: `${BASE_PATH}/sounds/sfx-sprite.mp3`,
      sprite: SFX_SPRITE_MAP,
      volume: 1,
    },

    // ========================================================================
    // STANDALONE SOUNDS - Not in sprite (music and looping sounds)
    // ========================================================================
    {
      name: "hold_and_win_music",
      url: `${BASE_PATH}/sounds/hold_and_win_music.mp3`,
      loop: false,
      volume: 1,
    },
    {
      name: "max_win_music",
      url: `${BASE_PATH}/sounds/max_win_music.mp3`,
      loop: true,
      volume: 1,
    },
  ],
};

// ============================================================================
// SOUND NAME MAPPINGS
// ============================================================================
// Maps all individual sound names (including sprite sounds) for easy reference
export const SOUND_NAME = {
  // Looping sounds
  ambient_music: "ambient_music",
  background_music: "background_music",
  feature_background_music: "feature_background_music",
  reel_spin: "reel_spin",
  feature_reel_spin: "feature_reel_spin",
  counter: "counter",
  collector_counter: "collector_counter",
  total_win_loop: "total_win_loop",
  win_music: "win_music",
  progress_bar_tension: "progress_bar_tension",
  tension_shake: "tension_shake",
  feature_tension: "feature_tension",

  // One-shot sounds (in sprite)
  win: "win",
  big_win: "big_win",
  mega_win: "mega_win",
  super_mega_win: "super_mega_win",
  button_click: "button_click",
  buy_bonus: "buy_bonus",
  spin: "spin",
  reel_stop: "reel_stop",
  add_respin: "add_respin",
  coin: "coin",
  coin_win: "coin_win",
  collector_add: "collector_add",
  collector_appear: "collector_appear",
  collector_particle: "collector_particle",
  progress_bar_add: "progress_bar_add",
  progress_bar_milestone: "progress_bar_milestone",
  progress_bar_multiplier: "progress_bar_multiplier",
  coin_multiplier: "coin_multiplier",
  expanding_wild: "expanding_wild",
  expanding_wild_multiplier: "expanding_wild_multiplier",
  expanding_wild_x2: "coin_multiplier", // x2 expanding wild uses multiplier sound
  tension: "tension",
  hold_and_win_in: "hold_and_win_in",
  hold_and_win_out: "hold_and_win_out",
  hold_and_win_music: "hold_and_win_music",
  hold_and_win_reload_in: "hold_and_win_reload_in",
  hold_and_win_reload_out: "hold_and_win_reload_out",
  max_win_in: "max_win_in",
  max_win_out: "max_win_out",
  max_win_music: "max_win_music",
  transition_in: "transition_in",
  transition_outro: "transition_outro",
  total_win_in: "total_win_in",
  total_win_out: "total_win_out",
  win_music_end: "win_music_end",
  wild: "wild",
  feature_end: "feature_end",
  feature_reel_stop: "feature_reel_stop",
  drop_1: "drop_1",
  drop_2: "drop_2",
  drop_3: "drop_3",
  drop_4: "drop_4",
  drop_5: "drop_5",
  drop_6: "drop_6",
  drop_7: "drop_7",
  drop_8: "drop_8",
  drop_9: "drop_9",
  drop_10: "drop_10",
  drop_11: "drop_11",
  drop_12: "drop_12",
};
